import { tickerItems } from '@/mocks/newsFeed';

export default function Ticker() {
  const loopItems = [...tickerItems, ...tickerItems];
  return (
    <section className="w-full bg-primary-500 text-background-50">
      <div className="flex items-stretch">
        <div className="hidden shrink-0 items-center gap-2 bg-primary-700 px-4 py-3 whitespace-nowrap md:flex md:px-6">
          <span className="h-2 w-2 rounded-full bg-accent-400 animate-pulse-soft" />
          <span className="font-label text-xs tracking-[0.24em]">实时快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-3">
          <div className="marquee-track flex">
            {loopItems.map((item, index) => (
              <span key={`${item}-${index}`} className="mx-5 flex items-center gap-2 text-sm whitespace-nowrap md:mx-8">
                <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                  <i className="ri-arrow-right-up-line" />
                </span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}